import { render, staticRenderFns } from "./CompanyAccountView.vue?vue&type=template&id=2e7b2cf1&"
import script from "./CompanyAccountView.vue?vue&type=script&lang=js&"
export * from "./CompanyAccountView.vue?vue&type=script&lang=js&"
import style0 from "./CompanyAccountView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!D:/ctg-code/qihuibao-web/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib'
installComponents(component, {VFlex})
